/* eslint-disable react-hooks/exhaustive-deps, no-use-before-define */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import usePush from '../../hooks/usePush';
import AuthenticationService from '../../services/authentication-service';
import LoadingMessage from '../../components/LoadingMessage/index';
import { useDispatch } from 'react-redux';
import { setUserData, setUserLocalStorage } from '../login/duck/actions/login';
import { login } from '../login/duck/actions/login';
import { useCacheActions } from '../../hooks/useFetch';
import OrganisationService from '../../services/organisation-service';
import useOrganisationInfo from '../../hooks/useOrganisationInfo';
import { pendo } from '../../util/logging';

// eslint-disable-next-line react/prop-types
const XeroCallback = ({ location: { search } }) => {
  const { execute } = usePush(AuthenticationService.loginXeroCallback);
  const history = useHistory();
  const dispatch = useDispatch();
  const { invalidateEndpoint } = useCacheActions();
  const organisation = useOrganisationInfo();

  const apiCall = async () => {
    const [err, result] = await execute(search);

    if (err) {
      history.push('/login', { loginError: 'Sorry unable to authenticate using Xero.' });
      return;
    }

    const newOrganisations = result?.data?.loginXeroCallback?.newOrganisations || [];
    const { user, token: userToken, isExternalAuthentication } = result?.data?.loginXeroCallback;

    user.token = userToken;
    user.isExternalAuthentication = isExternalAuthentication;
    dispatch(setUserData(user));

    pendo.track('integration_callback_completed', {
      integration: 'xero',
      isNewOrganisation: newOrganisations.length > 0,
    });

    if (newOrganisations.length > 0) {
      history.push(`/?organisation=${newOrganisations[0].ShortCode}`);
    } else if (organisation?.cashFlowIntelligence?.onboardingProcessInitiated) {
      history.push('/cashflow/forecast/onboarding?redirectedFromXero=true');
    } else {
      history.push('/');
    }

    await invalidateEndpoint(OrganisationService.get);
    setUserLocalStorage(user);
    dispatch(login());
  };

  useEffect(() => {
    apiCall();
  }, []);

  return <LoadingMessage center useLogoAnimation />;
};
export default XeroCallback;
